// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-SingleClient-bioBlock-___bioBlock__container___32OU4","para-text":"src-components-SingleClient-bioBlock-___bioBlock__para-text___1IT7w"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SingleClient/bioBlock/bioBlock.css
// module id = 1079
// module chunks = 0